// angular
import {NgClass} from "@angular/common";
import {Component, input, output} from "@angular/core";
import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
// material angular
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: "app-payload-button",
  templateUrl: "./payload-button.component.html",
  styleUrls: ["./payload-button.component.scss"],
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class PayloadButtonComponent {
  // inputs
  title = input<string>();
  titleKey = input<string>();
  disabled = input<boolean>();
  fullWidth = input<boolean>(true);
  link = input<string>();
  icon = input<string>();
  customClasses = input<string>("");

  // outputs
  clicked = output<Event>();

  public onClick(event: Event) {
    this.clicked.emit(event);
  }
}
